import React from "react";
import { Button } from "./Button";
import { Modal } from "react-bootstrap";
import { ClipboardIcon } from "./ClipboardIcon";
import { Copy, Envelope } from "react-bootstrap-icons";

interface InviteLinkDialogProps {
    show: boolean;
    onHide: () => void;
    inviteLink: string;
    parkerName: string;
    parkerEmail: string;
}

export function InviteLinkDialog({ show, onHide, inviteLink, parkerName, parkerEmail }: InviteLinkDialogProps) {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title><Envelope style={{ marginTop: '-8px' }} /> Invite Link</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                 
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control"
                            value={inviteLink}
                            readOnly
                            onFocus={(e) => e.target.select()}
                        />
                        <span className="input-group-text">
                            <ClipboardIcon
                                payload={inviteLink}
                                tooltipText="Link copied!"
                                icon={<Copy className="small" />}
                            />
                        </span>
                    </div>
                </div>
                <div className="text-muted small">
                    Share this link with {parkerName} at <b>{parkerEmail}</b> to allow them to complete their registration.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
} 